import React from 'react';
import { motion } from 'framer-motion';
import { useAnimateOnScroll } from '../hooks';

const envConfig = [
  { key: 'AI_INFRA_GPU', val: 'NVIDIA BCM, Run:AI, GPU Operator, Knative, Kserve, Kubeflow, SageMaker' },
  { key: 'KUBERNETES_DIST', val: 'Tanzu (VKS), OpenShift, EKS, AKS, GKE, Kubeadm (Bare Metal), Rancher, kOps' },
  { key: 'CLOUD_VIRTUALIZATION', val: 'VMware vSphere, VMware Cloud Foundation, AWS, Azure, GCP, Oracle, Alibaba' },
  { key: 'OS_AND_NETWORKING', val: 'Ubuntu, RHEL, TCP/IP, DNS, DHCP, Calico CNI, K8s Networking' },
  { key: 'PROVISIONING_IAC', val: 'Terraform, CloudFormation, Ansible' },
  { key: 'GITOPS_CICD', val: 'ArgoCD, Kustomize, Helm, GitLab CI, Jenkins, GitHub Actions' },
  { key: 'OBSERVABILITY', val: 'Prometheus, Grafana, ELK, Loki, Datadog, Coroot, Kubeshark, OpenTelemetry, Fluentd' },
  { key: 'SEC_IDENTITY', val: 'OIDC, SSO, Keycloak, CIS Benchmarks, Trivy, Private PKI, Secret Management' },
  { key: 'SCRIPTING_AUTO', val: 'Python, Bash, n8n, AWS Lambda, EventBridge' },
  { key: 'BLOCKCHAIN', val: 'Hyperledger Fabric, DApps, Smart Contracts' },
];

const Skills: React.FC = () => {
  const { ref, inView } = useAnimateOnScroll();

  return (
    <section id="skills" className="py-16 sm:py-20 bg-[#050505] px-4 sm:px-8 md:px-12 border-t border-zinc-900 overflow-hidden">
      <div className="max-w-6xl mx-auto" ref={ref}>
        
        <div className="mb-10 sm:mb-14">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-mono font-medium text-white uppercase tracking-tight mb-2">
            ~/Technical Expertise
          </h2>
          <div className="text-zinc-500 font-mono text-xs sm:text-sm tracking-widest uppercase">
            04 // Technical Stack & Tools
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="bg-[#0a0a0a] border border-zinc-800/80 p-4 sm:p-8 font-mono text-xs sm:text-sm shadow-2xl"
        >
          {/* Removed fixed width constraint, allow standard flex wrap */}
          <div className="w-full">
            {envConfig.map((item, i) => (
              <div key={i} className="flex flex-col lg:flex-row py-3 sm:py-4 hover:bg-zinc-900/50 transition-colors border-b border-zinc-900/50 last:border-0 gap-1 lg:gap-0">
                <div className="w-full lg:w-[35%] xl:w-[30%] text-zinc-500 tracking-wider shrink-0 select-none">
                  <span className="text-zinc-700">export</span> {item.key}=
                </div>
                <div className="w-full lg:w-[65%] xl:w-[70%] text-zinc-300 break-words pl-4 lg:pl-0">
                  "<span className="text-white font-medium">{item.val}</span>"
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;